/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum VideoFileType {
  video = 'video',
  audio = 'audio',
  transcript = 'transcript'
}
